export default __webpack_public_path__ + "static/media/Icon_Chat.6bceb2d7.svg";